import React from 'react';
import GridImage from './GridImage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const TelegraphProjectGrid = (props) => {
    let currentProjectIndex = props.projects.findIndex(project => project.path === props.path);
    let gridImages = props.projects[currentProjectIndex].gridImages;
    return (
        <div>
            <div className="project-slide"></div>
            <div className="project-grid telegraph-project container">
                <div className="flex">
                    {/*<img className="grid-img-1" src="/assets/img/homes/telegraph/02.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-1', asset: gridImages[1], sizes: ''}}/>
                    <svg className="grid-svg-1" x="0px" y="0px" width="260" height="373" viewBox="0 0 260 373">
                        <text className="telegraph-text" x="0" y="10" fill="#969696" textLength="1970">
                            <tspan x="0" className="barlow-li-it">telegraph</tspan>
                            <tspan x="0" dy="60" className="barlow-re">telegraph</tspan>
                            <tspan x="0" dy="60" className="barlow-me-it">telegraph</tspan>
                            <tspan x="0" dy="60" className="barlow-se-bo">telegraph</tspan>
                            <tspan x="0" dy="60" className="barlow-bo-it">telegraph</tspan>
                            <tspan x="0" dy="60" className="barlow-ex-bo">telegraph</tspan>
                            <tspan x="0" dy="60" className="barlow-bl-it">telegraph</tspan>
                        </text>
                    </svg>
                </div>
                <div className="flex">
                    <div className="grid-col-1">
                        <svg className="grid-svg-2" x="0px" y="0px" width="67" height="241" viewBox="0 0 67 241">
                            <text x="0" y="10" fill="#000">
                                <tspan x="0" className="yrsa-li">T</tspan>
                                <tspan x="0" dx="60" className="yrsa-li">E</tspan>
                                <tspan x="0" dy="46" className="yrsa-li">L</tspan>
                                <tspan x="0" dx="60" className="yrsa-li">E</tspan>
                                <tspan x="0" dx="33" dy="46" className="yrsa-se-bo" textAnchor="middle">G</tspan>
                                <tspan x="0" dx="33" dy="46" className="yrsa-se-bo" textAnchor="middle">R</tspan>
                                <tspan x="0" dy="46" className="yrsa-se-bo">A</tspan>
                                <tspan x="0" dx="60" className="yrsa-se-bo">P</tspan>
                                <tspan x="0" dx="33" dy="46" className="yrsa-se-bo" textAnchor="middle">H</tspan>
                            </text>
                        </svg>
                        {/*<img className="grid-img-2" src="/assets/img/homes/telegraph/04.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-2', asset: gridImages[3], sizes: ''}}/>
                    </div>
                    <div className="grid-col-2">
                        {/*<img className="grid-img-3" src="/assets/img/homes/telegraph/03.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-3', asset: gridImages[2], sizes: ''}}/>
                        <svg className="grid-svg-4" x="0px" y="0px" width="69" height="61" viewBox="0 0 69 61">
                            <text x="0" y="7" fill="#af2100">
                                <tspan x="0" className="barlow-me-it">t</tspan>
                                <tspan x="0" dx="63" className="barlow-me-it">e</tspan>
                                <tspan x="0" dy="53" className="barlow-me-it">l</tspan>
                                <tspan x="0" dx="63" className="barlow-me-it">e</tspan>
                            </text>
                        </svg>
                    </div>
                </div>
                <svg className="grid-svg-3" x="0px" y="0px" width="69" height="64" viewBox="0 0 69 64">
                    <text x="0" y="10" fill="#af2100">
                        <tspan x="0" className="barlow-it">t</tspan>
                        <tspan x="0" dx="63" className="barlow-it">e</tspan>
                        <tspan x="0" dy="53" className="barlow-it">l</tspan>
                        <tspan x="0" dx="63" className="barlow-it">e</tspan>
                    </text>
                </svg>
                {/*<img className="grid-img-4" src="/assets/img/homes/telegraph/05.jpg" alt=""/>*/}
                <GridImage params={{className: 'grid-img-4', asset: gridImages[4], sizes: ''}}/>
                <div className="flex flex-container-1">
                    <div className="grid-col-3">
                        <svg className="grid-svg-5" x="0px" y="0px" width="68" height="287" viewBox="0 0 68 287">
                            <text x="0" y="10" fill="#000">
                                <tspan x="0" dx="33" className="yrsa-li" textAnchor="middle">T</tspan>
                                <tspan x="0" dx="33" dy="46" className="yrsa-li" textAnchor="middle">E</tspan>
                                <tspan x="0" dx="33" dy="46" className="yrsa-li" textAnchor="middle">L</tspan>
                                <tspan x="0" dx="33" dy="46" className="yrsa-li" textAnchor="middle">E</tspan>
                                <tspan x="0" dy="46" className="yrsa-se-bo">G</tspan>
                                <tspan x="0" dx="60" className="yrsa-se-bo">R</tspan>
                                <tspan x="0" dx="33" dy="46" className="yrsa-se-bo" textAnchor="middle">A</tspan>
                                <tspan x="0" dy="46" className="yrsa-se-bo">P</tspan>
                                <tspan x="0" dx="60" className="yrsa-se-bo">H</tspan>
                            </text>
                        </svg>
                        {/*<img className="grid-img-5" src="/assets/img/homes/telegraph/07.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-5', asset: gridImages[6], sizes: ''}}/>
                        {/*<img className="grid-img-6" src="/assets/img/homes/telegraph/08.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-6', asset: gridImages[7], sizes: ''}}/>
                    </div>
                    <div className="grid-col-4">
                        {/*<img className="grid-img-7" src="/assets/img/homes/telegraph/06.jpg" alt=""/>*/}
                        <GridImage params={{className: 'grid-img-7', asset: gridImages[5], sizes: ''}}/>
                        <svg className="grid-svg-6" x="0px" y="0px" width="256" height="194" viewBox="0 0 256 194">
                            <text x="0" y="10" fill="#000">
                                <tspan x="94" className="yrsa-li">T</tspan>
                                <tspan x="154" className="yrsa-li" textAnchor="middle">E</tspan>
                                <tspan x="127" dy="46" className="yrsa-li" textAnchor="middle">L</tspan>
                                <tspan x="127" dy="46" className="yrsa-li" textAnchor="middle">E</tspan>
                                <tspan x="0" dy="46" className="yrsa-se-bo">G</tspan>
                                <tspan x="127" className="yrsa-se-bo" textAnchor="middle">R</tspan>
                                <tspan x="254" className="yrsa-se-bo" textAnchor="middle">A</tspan>
                                <tspan x="62" dy="46" className="yrsa-se-bo">P</tspan>
                                <tspan x="184" className="yrsa-se-bo">H</tspan>
                            </text>
                        </svg>
                    </div>
                </div>
                <div className="flex credits-container">
                    <div className="credits desktop">
                        <span className="credits-title red">Credits</span>
                        <ul className="no-style">
                            <li><span className="red barlow-me">Magazine</span> The Telegraph</li>
                            <li><span className="red barlow-me">Photographer</span> Coco Amardeil</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

// export default TelegraphProjectGrid;
const mapStateToProps = (state) => {
    return {
        projects: state.assets.projects
    };
};

export default withRouter(connect(mapStateToProps, null)(TelegraphProjectGrid));


// WEBPACK FOOTER //
// ./src/components/TelegraphProjectGrid.js